import React, { useCallback, useEffect, useState } from 'react';
import t from 'react-translate';
import { useSelector } from 'react-redux';
import { css } from '@emotion/react';
import { translationUpdate } from 'redux/actions/users';

import { useAppDispatch } from 'redux/store';
import { getCurrentUser } from 'redux/selectors/users';
import { TranslationInfo } from 'redux/schemas/models/edit-translations';
import { closeEditTranslationComponent } from 'redux/actions/edit-translations';
import { getLectureComponent } from 'redux/selectors/timeline';
import { ComponentType, LectureComponent } from 'redux/schemas/models/lecture-component';
import EditableTitleWithDescriptionStyled from './base/editable-title-and-description-styled';


type EditableProps = {
  editInfo: TranslationInfo,
  containerClass: string,
  onSaveRef: (fn: () => void) => void,
  setSavingDisabled: (boolean) => void,
};

const EditableDiscussion = ({
  editInfo,
  containerClass,
  onSaveRef,
  setSavingDisabled,
}: EditableProps) => {
  const lectureComponent = useSelector((state) => (
    getLectureComponent(state, editInfo.id)
  )) as LectureComponent<ComponentType.TOPIC>;
  const initialState = {
    title: lectureComponent.topic.title,
    description: lectureComponent.topic.body,
  };
  const [activity, setActivity] = useState(initialState);
  const currentUser = useSelector(getCurrentUser);
  const dispatch = useAppDispatch();

  const editableDiscussionStyle = css`
    width: 100%;
  `;

  const save = useCallback(() => {
    const { id } = editInfo;
    const attributes = [];
    const fields = Object.keys(activity);
    fields.forEach(field => {
      if (activity[field] !== initialState[field]) {
        const name = field === 'description' ? 'body' : field;
        attributes.push({
          translationId: lectureComponent.topic.translationIds[name],
          name,
          text: activity[field],
          elementType: lectureComponent.type,
          elementId: lectureComponent.topic.id,
        });
      }
    });
    const payload = {
      id,
      attributes,
    };
    dispatch(translationUpdate(payload)).then(() => {
      dispatch(closeEditTranslationComponent());
    });
  }, [activity, currentUser.translationPreferenceLanguage, dispatch, editInfo]);

  useEffect(() => {
    onSaveRef(() => save);
  }, [onSaveRef, save]);

  useEffect(() => {
    if (initialState !== activity) {
      setSavingDisabled(false);
    }
    return (() => {
      setSavingDisabled(true);
    });
  }, [activity]);


  return (
    <div className='editable-discussion' css={editableDiscussionStyle}>
      <EditableTitleWithDescriptionStyled
        activity={activity}
        setActivity={setActivity}
        containerClass={containerClass}
        titleName={t.AUTOMATED_TRANSLATION.EDIT_TRANSLATION.POST_TITLE()}
        descriptionName={t.AUTOMATED_TRANSLATION.EDIT_TRANSLATION.POST_CONTENT()}
      />
    </div>
  );
};

export default EditableDiscussion;
